module.exports = __webpack_public_path__ + "media/fonts/Oricons-93e276cae7963719c9359dc0b6c7b590.svg";